module.exports = __webpack_public_path__ + "static/media/206-gallery11.1dabd64a.jpg";